import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'brand_tile-click_brand_tile_image_scroll-click';

/**
 * This event tracks when users interact with the brand tile image scrolling.
 */
export function trackBrandTileClickBrandTileImageScrollClick(
  brandToken: string,
  Index: string,
  Action2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { brandToken, Index, Action2 },
  });
}
